import { Observable } from 'rxjs/Observable';
import { HttpErrorResponse } from '@angular/common/http';

export function ErrorHandler(err: HttpErrorResponse) {
    return Observable.throw(err);
}
